module.exports = __webpack_public_path__ + "static/media/video-camera.13f88e8d.svg";